export const searchFormOption_privacy = function () {
    return [
        {
            prop: 'username',
            label: '客户名称',
            type: 'input',
            placeholder: '客户名称'
        }
    ]
}

export default {}